// Desktop vs mobile UI switch.
//
// Convention: every page keeps its LOGIC in a shared hook and ships two separate
// UI files — `<Page>.desktop.jsx` and `<Page>.mobile.jsx`. The page's index picks
// one with `choose()`. The split is by PLATFORM, not screen size: the installed
// APK (Capacitor native) always renders the mobile UI; any browser renders the
// desktop UI. See CLAUDE.md → "Desktop / mobile UI split".
import { isNativeApp } from './deviceIdentity';

// True inside the Android APK (Capacitor native shell); false in any browser.
export const isMobileUI = () => isNativeApp();

// Pick a component for the current platform: choose(DesktopComp, MobileComp).
export const choose = (desktop, mobile) => (isMobileUI() ? mobile : desktop);
